// extracted by mini-css-extract-plugin
export var addButton = "_g8-0";
export var border = "_g8-8";
export var check = "_g8-h";
export var danger = "_g8-6";
export var dropdownContainer = "_g8-1";
export var editModalBody = "_g8-j";
export var footerContainer = "_g8-i";
export var fullWidth = "_g8-a";
export var hide = "_g8-9";
export var icon = "_g8-3";
export var input = "_g8-7";
export var inputFlex = "_g8-b";
export var inputWrapper = "_g8-c";
export var manualFocus = "_g8-5";
export var optionButton = "_g8-4";
export var pillWrapper = "_g8-e";
export var pointer = "_g8-2";
export var showOverflow = "_g8-f";
export var tagsFlex = "_g8-d";
export var xButton = "_g8-g";